/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-18 11:33:23
 * @LastEditors: hongye
 * @LastEditTime: 2026-02-04 09:55:03
 * @Description: file content
 */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { requestFail, requestError } from '@/utils'
import { useAuthStore, useSettingStore } from '@/store'
import LangType from '@/utils/i18n/LangType'
import { objKeySort, deleteNullKey } from '@/utils/index'
import { Md5 } from 'ts-md5'
import HTTP_CODE_STATUS from '@/utils/httpCode'
// 声明一些常量 混淆代码
const CONSTANT = {
  d: 'SITE',
  c: import.meta.env.VITE_COUNTRY,
  a: import.meta.env.VITE_APP_SIGNKEY
}
const CONSTANT_KEY = {
  t: 'ts',
  s: 'signKey',
}
if (CONSTANT.c === 'ID') {
  CONSTANT.c = 'IDN'
}
const axiosInstance = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  baseURL: import.meta.env.VITE_APP_API_BASE_URL
})
/**获取验签 */
const getTmpSign = (config: AxiosRequestConfig, _time: any) => {
  /**删除空值 */
  let params = deleteNullKey(config.data ? JSON.parse(config.data) : {})
  if (config.method === 'get') params = config.params ?? {}
  /**排序 */
  params = objKeySort(params)
  const reg = new RegExp('"', 'g')
  const reg2 = new RegExp(`'\''`, 'g')
  const key = `${JSON.stringify(params)}&${CONSTANT_KEY.t}=${_time}&${CONSTANT_KEY.s}=${CONSTANT.a}`.replaceAll(reg, '').replace(reg2, '')
  return Md5.hashStr(key).toUpperCase()
}
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const { locale } = useSettingStore()
    const _time = new Date().getTime()
    if (config.method === 'get') {
      const data = config.params || {}
      config.data = JSON.stringify(data)
    }
    Object.assign(config.headers!, {
      authToken: getToken(),
      sysCode: CONSTANT.d,
      [CONSTANT_KEY.t]: _time,
      language: LangType[locale],
      langType: LangType[locale],
      tmpSign: getTmpSign(config, _time),
      country: CONSTANT.c
    })
    return config
  },
  (error) => {
    return error
  }
)
// 响应拦截
axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => {
    if (res.status === 200) {
      const { data } = res
      const SUCCESS_CODES = [HTTP_CODE_STATUS.SUCCESS, HTTP_CODE_STATUS.TIME_BACK_STATUS]
      if (data?.code && !SUCCESS_CODES.includes(data.code)) requestFail(data)
    }
    return res
  },
  (err: AxiosError) => {
    requestError(err)
  }
)
export const getToken = () => {
  const authStore = useAuthStore()
  return authStore?.token
}
export default axiosInstance
